<template>
  <div class="sup-swiper">
    <div class="top-show">
      <div class="topdiv">
        <topbox :add='add' ref= "sup-swiper"></topbox>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="in-swiper">
      <el-carousel height="440px">
        <el-carousel-item v-for="(swiper,i) in swiperSlideData" :key="i">
          <img :src="swiper.imgSrc" style="object-fit:cover;"/>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>


<script>
import topbox from "./Topbox.vue";
import {mapGetters} from 'vuex'
export default {

  //多语言刷新
  // props:{
  //       add:{
  //           type: Function
  //       }
  //   },

  components: {
    topbox: topbox
  },
  data() {
    return {
      swiperSlideData: JSON.parse(this.$supMainPageConfig).srmSwiper.swiperSlide
    };
  },
  
  computed: {
      //store里面取数据
    ...mapGetters(['supMainPageConfig']),
     swiperSlideData: function()  {
      return JSON.parse(this.supMainPageConfig).srmSwiper.swiperSlide;
    },
  }

};
</script>

<style scoped lang="scss">
.sup-swiper {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 440px;
}
.top-show {
  width: 100%;
  position: absolute;
  z-index: 2;
  height: 64px;
  background: rgba(26, 28, 53, 0.2);
  display: flex;
}
.topdiv {
  width: 1200px;
  margin: 0 auto;
}
.in-swiper {
  position: relative;
  width: 100%;
  height: 440px;
  z-index: 1;
}
.sup-swiper img {
  width: 100%;
  height: 440px;
}
.in-swiper .swiper-pagination {
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
